import { Typography } from "@mui/material";
import React from "react";

const Copyright = (props) => {
  const { isShowOwner } = props;
  return (
    <Typography {...props}>
      <div>{"Copyright © 2023 "}</div>
      <div className={isShowOwner ? "" : "d-none"}>
        {" "}
        ฝ่ายพัฒนานิสิต คณะวิศวกรรมศาตร์ มหาวิทยาลัยบูรพา
      </div>
      <div>Version 1.3.3</div>
    </Typography>
  );
};

export default Copyright;
